import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/manufacturers/[id]/page.tsx");
